'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('@babel/runtime/helpers/extends'));
var _regeneratorRuntime = _interopDefault(require('@babel/runtime/regenerator'));
var effects = require('redux-saga/effects');
var Apollo = require('@engaging-tech/graphql');
var Apollo__default = _interopDefault(Apollo);
var ssrConfig = require('@engaging-tech/ssr-config');
var _taggedTemplateLiteralLoose = _interopDefault(require('@babel/runtime/helpers/taggedTemplateLiteralLoose'));
var reselect = require('reselect');
var React = require('react');
var React__default = _interopDefault(React);
var reactRedux = require('react-redux');
var _objectWithoutPropertiesLoose = _interopDefault(require('@babel/runtime/helpers/objectWithoutPropertiesLoose'));
var components = require('@engaging-tech/components');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var charts = require('@engaging-tech/charts');
var frontendUtils = require('@engaging-tech/frontend-utils');
var reactDom = require('react-dom');

var types = {
  LOAD: "[Results] Load",
  LOAD_SUCCESS: "[Results] Load Success",
  LOAD_FAIL: "[Results] Load Fail",
  RETRY_LOAD: "[Results] Retry Load"
};
var load = function load(submissionId) {
  return {
    type: types.LOAD,
    payload: submissionId
  };
};
var loadSuccess = function loadSuccess(results) {
  return {
    type: types.LOAD_SUCCESS,
    payload: results
  };
};
var loadFail = function loadFail() {
  return {
    type: types.LOAD_FAIL
  };
};
var retryLoad = function retryLoad(submissionId) {
  return {
    type: types.RETRY_LOAD,
    payload: submissionId
  };
};

var result_actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  types: types,
  load: load,
  loadSuccess: loadSuccess,
  loadFail: loadFail,
  retryLoad: retryLoad
});

var initialState = {
  isLoading: false,
  results: null
};
var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case types.LOAD:
    case types.RETRY_LOAD:
      return _extends({}, state, {
        isLoading: true
      });

    case types.LOAD_SUCCESS:
      return _extends({}, state, {
        results: action.payload,
        isLoading: false
      });

    case types.LOAD_FAIL:
      return _extends({}, state, {
        isLoading: false
      });

    default:
      return state;
  }
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  query($id: ID!) {\n    getSurveyResults(surveySubmissionId: $id) {\n      status\n      completedAt\n      template {\n        sections {\n          questions {\n            id\n            title\n            type\n          }\n        }\n        results {\n          section\n          questions\n        }\n      }\n      answers {\n        questionId\n        values\n      }\n      results {\n        scores {\n          section\n          score\n          comparison {\n            global\n            industry\n          }\n        }\n        matrices {\n          section\n          title\n          description\n          bands {\n            topLeft {\n              title\n              description\n            }\n            topRight {\n              title\n              description\n            }\n            bottomLeft {\n              title\n              description\n            }\n            bottomRight {\n              title\n              description\n            }\n          }\n          axis {\n            xAxis {\n              heading\n              questions\n            }\n            yAxis {\n              heading\n              questions\n            }\n          }\n          values {\n            label\n            values {\n              x\n              y\n            }\n          }\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var LOAD = Apollo.gql(_templateObject());

/* eslint-disable import/prefer-default-export */

var GRAPHQL_API_URL = function GRAPHQL_API_URL() {
  return "" + ssrConfig.getConfig().api.url + ssrConfig.getConfig().api.endpoints.graphql;
};

var apollo = new Apollo__default();
var load$1 = function load(id) {
  return apollo.query({
    uri: GRAPHQL_API_URL,
    query: LOAD,
    variables: {
      id: id
    }
  });
};

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(loadSaga),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(saga);
var resultsLifecycle = {
  pending: "pending",
  processed: "processed"
};
var RETRY_TIMEOUT = 2000;
function loadSaga(action, retryTimeout) {
  var res, results;
  return _regeneratorRuntime.wrap(function loadSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (retryTimeout === void 0) {
            retryTimeout = RETRY_TIMEOUT;
          }

          _context.prev = 1;
          _context.next = 4;
          return effects.call(load$1, action.payload);

        case 4:
          res = _context.sent;
          results = res.data.getSurveyResults;

          if (!(results.status === resultsLifecycle.processed)) {
            _context.next = 11;
            break;
          }

          _context.next = 9;
          return effects.put(loadSuccess(results));

        case 9:
          _context.next = 15;
          break;

        case 11:
          _context.next = 13;
          return effects.delay(retryTimeout);

        case 13:
          _context.next = 15;
          return effects.put(retryLoad(action.payload));

        case 15:
          _context.next = 21;
          break;

        case 17:
          _context.prev = 17;
          _context.t0 = _context["catch"](1);
          _context.next = 21;
          return effects.put(loadFail());

        case 21:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 17]]);
}
function saga() {
  return _regeneratorRuntime.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return effects.takeLatest([types.LOAD, types.RETRY_LOAD], loadSaga);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var getResultsState = function getResultsState(state) {
  return state.surveyResults.results;
};

var getTemplateState = function getTemplateState(state) {
  return getResultsState(state).template;
};

var getQuestionsState = function getQuestionsState(state) {
  return getTemplateState(state).sections[0].questions;
};

var getAnswersState = function getAnswersState(state) {
  return getResultsState(state).answers;
};

var getCompletionDate = reselect.createSelector(getResultsState, function (state) {
  return state.completedAt;
});
var getResults = reselect.createSelector(getResultsState, function (state) {
  return state && state.results;
});
var getHasResults = reselect.createSelector(getResults, function (results) {
  return !!results;
});
var getResultsScores = reselect.createSelector(getResults, function (results) {
  return results.scores;
});

var getResultBySection = function getResultBySection(state, section) {
  var scoresState = getResultsScores(state);
  return scoresState.find(function (sectionResult) {
    return sectionResult.section === section;
  });
};

var getScoreResult = reselect.createSelector(getResultBySection, function (result) {
  return result;
});

var getQuestionById = function getQuestionById(state, questionId) {
  var questions = getQuestionsState(state);
  var answersState = getAnswersState(state);

  var _questions$find = questions.find(function (question) {
    return question.id === questionId;
  }),
      title = _questions$find.title;

  var answers = answersState.find(function (answerValue) {
    return answerValue.questionId === questionId;
  }).values;
  return {
    title: title,
    answers: answers
  };
};

var mapIdsToQuestion = function mapIdsToQuestion(questionIds, state) {
  return questionIds.map(function (id) {
    return getQuestionById(state, id);
  });
};

var getQuestionIdsBySection = function getQuestionIdsBySection(state, section) {
  var template = getTemplateState(state);
  return template.results && template.results.find(function (result) {
    return result.section === section;
  }).questions;
};

var getQuestions = reselect.createSelector([getQuestionIdsBySection, function (state) {
  return state;
}], mapIdsToQuestion);
var getHappinessScore = reselect.createSelector(getResultsScores, function (scores) {
  return scores.find(function (result) {
    return result.section === "happinessScore";
  });
});
var getAllMatricesState = reselect.createSelector(getResults, function (results) {
  return results.matrices;
});

var extractMatrixSection = function extractMatrixSection(matrix) {
  return matrix.section;
};

var extractMatrixData = function extractMatrixData(matrix) {
  return matrix.values && matrix.values.reduce(function (matrixData, currVal) {
    var _extends2;

    return _extends({}, matrixData, (_extends2 = {}, _extends2[currVal.label] = {
      x: parseInt(currVal.values.x * 100, 10),
      y: parseInt(currVal.values.y * 100, 10)
    }, _extends2));
  }, {});
};

var extractMatrixTitle = function extractMatrixTitle(matrix) {
  return matrix.title;
};

var extractMatrixDescription = function extractMatrixDescription(matrix) {
  return matrix.description;
};

var extractMatrixAxisLabels = function extractMatrixAxisLabels(matrix) {
  return matrix && matrix.axis ? {
    xAxisLabels: matrix.axis.xAxis,
    yAxisLabels: matrix.axis.yAxis
  } : null;
};

var extractMatrixQuadrantLabels = function extractMatrixQuadrantLabels(matrix) {
  return matrix.bands;
};

var getMatrices = reselect.createSelector(getAllMatricesState, function (allMatrices) {
  return allMatrices.map(function (matrix) {
    return {
      section: extractMatrixSection(matrix),
      data: extractMatrixData(matrix),
      title: extractMatrixTitle(matrix),
      description: extractMatrixDescription(matrix),
      axisLabels: extractMatrixAxisLabels(matrix),
      quadrantLabels: extractMatrixQuadrantLabels(matrix)
    };
  });
});

var result_selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCompletionDate: getCompletionDate,
  getResults: getResults,
  getHasResults: getHasResults,
  getResultsScores: getResultsScores,
  getScoreResult: getScoreResult,
  getQuestions: getQuestions,
  getHappinessScore: getHappinessScore,
  getAllMatricesState: getAllMatricesState,
  getMatrices: getMatrices
});

var LoaderComponent = function LoaderComponent(_ref) {
  var onLoad = _ref.onLoad;
  React.useEffect(function () {
    onLoad();
  }, [onLoad]);
  return null;
};

var mapDispatch = function mapDispatch(dispatch, props) {
  return {
    onLoad: function onLoad() {
      return dispatch(load(props.submissionId));
    }
  };
};

var Loader = reactRedux.connect(null, mapDispatch)(LoaderComponent);

var ResultCard = function ResultCard(_ref) {
  var children = _ref.children,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1 / 1 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "auto" : _ref$height,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? "auto" : _ref$minHeight,
      _ref$mt = _ref.mt,
      mt = _ref$mt === void 0 ? [3, 5] : _ref$mt,
      _ref$p = _ref.p,
      p = _ref$p === void 0 ? [3, 3, 4] : _ref$p,
      _ref$justifyContent = _ref.justifyContent,
      justifyContent = _ref$justifyContent === void 0 ? "flex-start" : _ref$justifyContent,
      _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? "flex-start" : _ref$alignItems,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "width", "height", "minHeight", "mt", "p", "justifyContent", "alignItems"]);

  return React__default.createElement(components.Card, _extends({
    width: width,
    justifyContent: justifyContent,
    flexDirection: ["column", "row"],
    elevation: 2,
    mt: mt,
    alignItems: alignItems,
    p: p,
    height: height,
    minHeight: minHeight
  }, props), children);
};

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  div {\n    border-left: 2px solid ", ";\n    span {\n      margin: 0 8px;\n    }\n  }\n  div:first-child {\n    border: none;\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var BorderedFlex = styled__default(components.Flex)(_templateObject$1(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[6];
});

var getIndustryComparisonText = function getIndustryComparisonText(score) {
  return score.toFixed(0) + "% " + (score >= 0 ? "above" : "below");
};

var StatisticBox = function StatisticBox(_ref2) {
  var comparedToIndustry = _ref2.comparedToIndustry;
  return React__default.createElement(BorderedFlex, {
    width: [1 / 1, 9 / 10],
    height: 104,
    bg: "dark.7",
    mb: 4,
    alignItems: "center",
    justifyContent: "space-evenly"
  }, React__default.createElement(components.Flex, {
    width: "auto",
    flexDirection: "column"
  }, React__default.createElement(components.Text, {
    color: "dark.2",
    fontSize: 2,
    pb: 1
  }, "Trend"), React__default.createElement(components.Text, {
    fontSize: 2
  }, "No Data to Compare")), React__default.createElement(components.Flex, {
    width: "auto",
    flexDirection: "column"
  }, React__default.createElement(components.Text, {
    color: "dark.2",
    fontSize: 2,
    pb: 1
  }, "Change since last survey"), React__default.createElement(components.Text, {
    fontSize: 2
  }, "No Data to Compare")), React__default.createElement(components.Flex, {
    width: "auto",
    flexDirection: "column"
  }, React__default.createElement(components.Text, {
    color: "dark.2",
    fontSize: 2,
    pb: 1
  }, "Compared to industry"), React__default.createElement(components.Text, null, getIndustryComparisonText(comparedToIndustry))));
};

var ReportItem = function ReportItem(_ref) {
  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      children = _ref.children,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "inherit" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "auto" : _ref$height,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? 5 : _ref$mb;
  return React__default.createElement(components.Card, {
    elevation: 0,
    alignItems: "center",
    width: width,
    height: height
  }, heading && React__default.createElement(components.H2, {
    fontSize: 5,
    fontWeight: 500,
    mb: !subHeading ? mb : 2
  }, heading), subHeading && React__default.createElement(components.Paragraph, {
    fontSize: 3,
    color: "dark.2"
  }, subHeading), children);
};

var getLabelData = function getLabelData(theScore) {
  var colorsMatrix = [{
    color: "#BF4630",
    text: "Improvement Required",
    icon: "error"
  }, {
    color: "#BF4630",
    text: "Improvement Recommended",
    icon: "error"
  }, {
    color: "#FF9800",
    text: "Improvement Advised",
    icon: "error"
  }, {
    color: "#00BB88",
    text: "Good Score!",
    icon: "check_circle"
  }, {
    color: "#00BB88",
    text: "Excellent!",
    icon: "check_circle"
  }];
  if (theScore > 80) return colorsMatrix[4];
  if (theScore > 60) return colorsMatrix[3];
  if (theScore > 40) return colorsMatrix[2];
  if (theScore > 20) return colorsMatrix[1];
  return colorsMatrix[0];
};

var ScoreLabel = function ScoreLabel(_ref) {
  var score = _ref.score,
      noIcon = _ref.noIcon,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "inherit" : _ref$width,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 3 : _ref$fontSize;
  var labelData = getLabelData(score);
  return React__default.createElement(components.Flex, {
    justifyContent: "center",
    alignItems: "center",
    width: width
  }, !noIcon && React__default.createElement(components.Icon, {
    name: labelData.icon,
    color: labelData.color,
    mr: 0,
    width: "auto"
  }), React__default.createElement(components.Text, {
    color: labelData.color,
    pl: 1,
    fontWeight: 500,
    width: "auto",
    fontSize: fontSize
  }, labelData.text));
};

var PercentageGraphic = function PercentageGraphic(_ref) {
  var score = _ref.score,
      text = _ref.text,
      isLowest = _ref.isLowest,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 200 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 1 / 1 : _ref$width,
      _ref$justifyContent = _ref.justifyContent,
      justifyContent = _ref$justifyContent === void 0 ? "center" : _ref$justifyContent,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? "auto" : _ref$maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? "auto" : _ref$maxHeight,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 400 : _ref$size,
      _ref$graphicWidth = _ref.graphicWidth,
      graphicWidth = _ref$graphicWidth === void 0 ? 160 : _ref$graphicWidth,
      props = _objectWithoutPropertiesLoose(_ref, ["score", "text", "isLowest", "height", "width", "justifyContent", "maxWidth", "maxHeight", "size", "graphicWidth"]);

  return React__default.createElement(components.Box, _extends({
    width: width,
    height: height,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    my: 2
  }, props), React__default.createElement(components.Flex, {
    flexDirection: "column",
    justifyContent: justifyContent,
    alignItems: "center",
    width: 1 / 1,
    height: height,
    maxWidth: maxWidth,
    maxHeight: maxHeight
  }, React__default.createElement(charts.CircularProgress, {
    px: [2, 0],
    percentage: score || 0,
    width: graphicWidth,
    strokeColor: getLabelData(score).color,
    size: size
  }), !score && score !== 0 && React__default.createElement(components.Text, {
    textAlign: "center"
  }, "No data for this step"), text && React__default.createElement(components.Text, {
    textAlign: "center",
    fontWeight: 500,
    color: "dark.2",
    fontSize: 3,
    width: 3 / 4
  }, text), React__default.createElement(ScoreLabel, {
    score: score
  }), isLowest && React__default.createElement(components.Text, {
    color: "#BF4630",
    fontSize: 3,
    fontWeight: 500,
    width: "auto"
  }, "LOWEST SCORE")));
};

var convertToPercentage = function convertToPercentage(score) {
  return parseInt(score * 100, 10);
};

var calculateIndustryComparison = function calculateIndustryComparison(score, industryScore) {
  return convertToPercentage(score - industryScore);
};

var months = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

var formatDate = function formatDate(date) {
  return date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear();
};

var Dial = function Dial(_ref) {
  var score = _ref.score,
      industryScore = _ref.industryScore,
      completedAt = _ref.completedAt;
  return React__default.createElement(ReportItem, {
    heading: "Happiness Score",
    subHeading: "Survey completed on: " + formatDate(new Date(completedAt))
  }, React__default.createElement(PercentageGraphic, {
    score: convertToPercentage(score)
  }), React__default.createElement(StatisticBox, {
    comparedToIndustry: calculateIndustryComparison(score, industryScore)
  }));
};

var convertToPercentage$1 = function convertToPercentage(score) {
  return parseInt(score * 100, 10);
};

var Chart = function Chart(_ref) {
  var score = _ref.score,
      industryScore = _ref.industryScore,
      globalScore = _ref.globalScore;
  return React__default.createElement(ReportItem, {
    heading: "Compare Your Score",
    subHeading: "Compare your happiness score for this survey against the global average as well as for your industry."
  }, React__default.createElement(charts.PercentageBar, {
    data: [convertToPercentage$1(score), convertToPercentage$1(industryScore), convertToPercentage$1(globalScore)],
    labels: ["You", "Industry", "Global"]
  }));
};

var Score = function Score(_ref) {
  var happinessResult = _ref.happinessResult,
      completedAt = _ref.completedAt;
  var score = happinessResult.score;
  var _happinessResult$comp = happinessResult.comparison,
      industryScore = _happinessResult$comp.industry,
      globalScore = _happinessResult$comp.global;
  return React__default.createElement(ResultCard, null, React__default.createElement(Dial, {
    score: score,
    industryScore: industryScore,
    completedAt: completedAt
  }), React__default.createElement(Chart, {
    score: score,
    industryScore: industryScore,
    globalScore: globalScore
  }));
};

var mapState = function mapState(state) {
  return {
    happinessResult: getHappinessScore(state),
    completedAt: getCompletionDate(state)
  };
};

var OverallScore = reactRedux.connect(mapState)(Score);

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n\n  &:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var ButtonFlex = styled__default(components.Flex)(_templateObject$2(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondary[1];
});

var ResultsMatrix = function ResultsMatrix(_ref2) {
  var title = _ref2.title,
      description = _ref2.description,
      icon = _ref2.icon,
      callToActionDescription = _ref2.callToActionDescription,
      data = _ref2.data,
      axisLabels = _ref2.axisLabels,
      quadrantLabels = _ref2.quadrantLabels,
      buttonText = _ref2.buttonText,
      path = _ref2.path;

  var _useState = React.useState(false),
      showOverlay = _useState[0],
      setShowOverlay = _useState[1];

  var xAxisLabels = axisLabels.xAxisLabels,
      yAxisLabels = axisLabels.yAxisLabels;
  return React__default.createElement(components.Accordion, {
    icon: icon,
    title: frontendUtils.titleCaps(title),
    description: description
  }, React__default.createElement(components.Text, {
    fontSize: 3,
    color: "dark.2"
  }, "Hover over labels and bubbles to reveal the information and meaning behind them."), React__default.createElement(components.Flex, {
    justifyContent: "flex-end",
    alignItems: "center",
    my: 2
  }, React__default.createElement(components.Button, {
    variant: "text.primary.0",
    trailingIcon: "help",
    color: "primary.0",
    fontSize: 2,
    elevation: 0,
    onClick: function onClick() {
      return setShowOverlay(!showOverlay);
    }
  }, "Show Label Descriptions")), React__default.createElement(components.Box, {
    width: 1 / 1
  }, React__default.createElement(charts.ResultsMatrix, {
    data: data,
    yAxisLabels: yAxisLabels,
    xAxisLabels: xAxisLabels,
    quadrantLabels: quadrantLabels,
    overlay: showOverlay
  })), React__default.createElement(components.Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, React__default.createElement(components.Box, {
    width: [3 / 5, 3 / 5, 7 / 10],
    p: 3,
    bg: "secondary.3",
    my: 4
  }, React__default.createElement(components.Text, {
    textAlign: "center",
    fontSize: 3,
    color: "dark.2"
  }, callToActionDescription)), React__default.createElement("a", {
    href: path,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React__default.createElement(ButtonFlex, {
    bg: "secondary.0",
    py: 2,
    mr: [0, 5, 4],
    minWidth: "250px",
    justifyContent: "center",
    borderRadius: 200,
    elevation: 1
  }, React__default.createElement(components.Text, {
    fontSize: [2, 2, 3],
    fontWeight: 500,
    width: "auto",
    color: "dark.2",
    mx: [0, 0, 2]
  }, buttonText)))));
};

var Matrices = function Matrices(_ref) {
  var matricesInformation = _ref.matricesInformation;
  return React__default.createElement(ResultCard, null, React__default.createElement(ReportItem, {
    heading: "Results Matrices"
  }, matricesInformation.map(function (matrixInfo, index) {
    return React__default.createElement(ResultsMatrix, {
      key: matrixInfo.title + "-" + index.toString(),
      title: matrixInfo.title,
      buttonText: matrixInfo.buttonText,
      path: matrixInfo.path,
      description: matrixInfo.description,
      icon: matrixInfo.icon,
      callToActionDescription: matrixInfo.callToActionDescription,
      data: matrixInfo.data,
      axisLabels: matrixInfo.axisLabels || {},
      quadrantLabels: matrixInfo.quadrantLabels || {}
    });
  })));
};

var matricesInfo = [{
  section: "matrices_jobSatisfaction",
  icon: "case-tick",
  callToActionDescription: "If you are considering changing your job, a good place to start is by taking our career tests to ensure you are working in the best industry for you.",
  buttonText: "Take Tests",
  path: "https://v1.engaging.works/ew/profile"
}, {
  section: "matrices_organisationSatisfaction",
  icon: "boost",
  callToActionDescription: "If you are considering looking for a new role, you can browse jobs for free on the jobs board.",
  buttonText: "BROWSE JOBS",
  path: "https://engaging.works/find-work"
}, {
  section: "matrices_wellBeing",
  icon: "sunny",
  callToActionDescription: ["If you are concerned about your Mental Health Well-being score, a great way to have a more in-depth exploration of this area is to take our well-being test, which is specifically tailored to explore your mental health and well-being. ", React__default.createElement("strong", null, "If your score is less than 60% we would highly recommend that you take this test.")],
  buttonText: "Take Well-Being Assessment",
  path: "https://v1.engaging.works/ew/profile"
}, {
  section: "matrices_careerDevelopment",
  icon: "school",
  callToActionDescription: "Need help developing your career? Take our purposefully designed tests to help your Career Development.",
  buttonText: "Develop your Career",
  path: "https://v1.engaging.works/ew/profile"
}, {
  section: "matrices_inclusiveness",
  icon: "supervised_user_circle",
  callToActionDescription: "For help getting your views heard at work, we recommend signing up and sharing your concerns or asking for help on the Global Hub.",
  buttonText: "Get advice on Global Hub",
  path: "https://engaging.works/global-hub"
}, {
  section: "matrices_empowerment",
  icon: "accessibility",
  callToActionDescription: "If you feel you are in the right role, but would like advice about how to improve your overall career path, connect via our Mentor Matcher Service with an expert in your industry to get help and advice.",
  buttonText: "Find a mentor",
  path: "https://engaging.works/global-hub"
}, {
  section: "matrices_senseOfPurpose",
  icon: "trending_up",
  callToActionDescription: "The Business Library is our world-wide business materials collection with thousands of articles, podcasts, research pieces and lectures for you to discover in order to define the sense of purpose in your career.",
  buttonText: "Business Library",
  path: "https://engaging.works/business-library"
}, {
  section: "matrices_lineManagerRelationship",
  icon: "conference_speaker",
  callToActionDescription: "If you need help developing your relationship with your line manager at work, we would suggest connecting with a mentor to get advice. Use our FREE mentor matcher service.",
  buttonText: "Find a Mentor",
  path: "https://v1.engaging.works/ew/mentors/matcher"
}, {
  section: "matrices_workplaceEnvironment",
  icon: "wb_incandescent",
  callToActionDescription: "View world-wide companies listed by happy workplace environments on our Happiest Companies ranking. Rank your own company anonymously.",
  buttonText: "Happiest Companies",
  path: "https://engaging.works/find-work/rankings/"
}];

var mapState$1 = function mapState(state) {
  return {
    matricesInformation: getMatrices(state).map(function (matrix) {
      return _extends({}, matrix, {}, matricesInfo.find(function (info) {
        return info.section === matrix.section;
      }));
    })
  };
};

var Matrices$1 = reactRedux.connect(mapState$1)(Matrices);

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  animation: ", ";\n  animation-duration: ", "s;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var ANIMATION_DURATION = 1;
var FadeIn = styled.keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var AnimatedText = styled__default(components.Text)(_templateObject$3(), FadeIn, ANIMATION_DURATION);

var LoadingText = function LoadingText(_ref) {
  var children = _ref.children;
  return React__default.createElement(AnimatedText, {
    textAlign: "center",
    fontSize: [3, 5],
    color: "dark.1",
    mt: 16,
    fontWeight: "500"
  }, children);
};

var statuses = ["Calculating your Six Steps scores...", "Calculating your workplace happiness score...", "Comparing your score globally..."].map(function (status) {
  return React__default.createElement(LoadingText, {
    key: status
  }, status);
});

var HoldingPage = function HoldingPage() {
  var _useState = React.useState(0),
      currentStatus = _useState[0],
      setCurrentStatus = _useState[1];

  var handleStatus = function handleStatus(statusIndex) {
    if (statusIndex === statuses.length - 1) setCurrentStatus(0);else setCurrentStatus(statusIndex + 1);
  };

  React.useEffect(function () {
    var timer = setTimeout(function () {
      handleStatus(currentStatus);
    }, Math.floor(Math.random() * 6) * 1000 + 2000);
    return function () {
      return clearTimeout(timer);
    };
  });
  return React__default.createElement(components.Flex, {
    width: 1 / 1,
    maxWidth: 1080,
    flexDirection: "column",
    alignItems: "center"
  }, React__default.createElement(components.H2, {
    fontSize: [5, 7],
    fontWeight: 500,
    fontFamily: "serif"
  }, "Thank you for completing the survey!"), React__default.createElement(components.Card, {
    width: 1 / 1,
    minHeight: [210, 420],
    justifyContent: "center",
    alignItems: "center",
    elevation: 2,
    my: [3, 5],
    bg: "dark.7"
  }, React__default.createElement(components.Spinner, {
    color: "primary.0",
    width: 100,
    height: 100
  }), React__default.createElement(components.Text, {
    textAlign: "center",
    fontSize: [3, 5],
    color: "dark.1",
    mt: 16
  }, "Crunching the numbers"), statuses[currentStatus]), React__default.createElement(components.TabletUp, {
    width: 1 / 1
  }, React__default.createElement(components.Card, {
    width: 1 / 1,
    bg: "dark.7",
    minHeight: [600],
    justifyContent: "center"
  }, React__default.createElement(components.Flex, {
    justifyContent: "space-evenly"
  }, React__default.createElement(components.Box, {
    width: 180,
    height: 146,
    bg: "dark.7"
  }), React__default.createElement(components.Box, {
    width: 180,
    height: 146,
    bg: "dark.7"
  }), React__default.createElement(components.Box, {
    width: 180,
    height: 146,
    bg: "dark.7"
  })), React__default.createElement(components.Flex, {
    justifyContent: "space-evenly",
    pt: 7
  }, React__default.createElement(components.Box, {
    width: 180,
    height: 146,
    bg: "dark.7"
  }), React__default.createElement(components.Box, {
    width: 180,
    height: 146,
    bg: "dark.7"
  }), React__default.createElement(components.Box, {
    width: 180,
    height: 146,
    bg: "dark.7"
  })))));
};

var Title = function Title(_ref) {
  var _ref$titleText = _ref.titleText,
      titleText = _ref$titleText === void 0 ? "Thank you for completing the survey!" : _ref$titleText,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? "Here are your results" : _ref$subtitle,
      _ref$titleFontSize = _ref.titleFontSize,
      titleFontSize = _ref$titleFontSize === void 0 ? [5, 7] : _ref$titleFontSize,
      _ref$subHeadingFontSi = _ref.subHeadingFontSize,
      subHeadingFontSize = _ref$subHeadingFontSi === void 0 ? [3, 4] : _ref$subHeadingFontSi,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "auto" : _ref$width;
  return React__default.createElement(components.Flex, {
    flexDirection: "column",
    width: width
  }, React__default.createElement(components.H2, {
    fontSize: titleFontSize,
    fontWeight: 500,
    fontFamily: "serif",
    width: 1 / 1
  }, titleText), React__default.createElement(components.Text, {
    fontSize: subHeadingFontSize,
    my: 3,
    color: "dark.2",
    width: 1 / 1
  }, subtitle));
};

var ExplanationTopBar = function ExplanationTopBar(_ref) {
  var setVisibility = _ref.setVisibility,
      heading = _ref.heading;
  return React__default.createElement(components.Flex, {
    width: 1 / 1,
    height: [2, 3],
    bg: "dark.7",
    alignItems: "center"
  }, React__default.createElement(components.Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, React__default.createElement(components.Box, {
    width: 1 / 10
  }), React__default.createElement(components.Text, {
    width: 8 / 10,
    fontSize: [3, 5],
    fontWeight: 500,
    textAlign: "center"
  }, heading), React__default.createElement(components.IconButton, {
    onClick: function onClick() {
      return setVisibility(false);
    },
    icon: "clear"
  })));
};

var BreakdownRow = function BreakdownRow(_ref) {
  var rowNum = _ref.rowNum,
      title = _ref.title,
      percentage = _ref.percentage;
  var score = percentage * 10;
  return React__default.createElement(components.Flex, {
    width: 1 / 1,
    height: 3,
    alignItems: "center",
    justifyContent: "space-between"
  }, React__default.createElement(components.Flex, {
    width: 9 / 10,
    pr: [2, 0]
  }, React__default.createElement(components.Text, {
    width: "auto",
    fontSize: 3,
    color: "dark.2",
    mr: 3,
    fontWeight: 500
  }, "" + rowNum), React__default.createElement(components.Text, {
    width: "auto",
    fontSize: 3,
    color: "dark.2"
  }, title)), React__default.createElement(components.Text, {
    width: "auto",
    fontSize: 3,
    color: getLabelData(score).color,
    fontWeight: 500
  }, "" + score, "%"));
};

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  div {\n    border-top: 2px solid ", ";\n  }\n  div:first-child {\n    border: none;\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var QuestionsContainer = styled__default(components.Flex)(_templateObject$4(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[6];
});

var Breakdown = function Breakdown(_ref2) {
  var questions = _ref2.questions;
  return React__default.createElement(components.Box, {
    bg: "dark.7",
    px: [2, 5],
    py: [0, 3],
    borderRadius: 4,
    mt: 3,
    mb: [3, 5]
  }, React__default.createElement(QuestionsContainer, {
    width: 1 / 1,
    flexDirection: "column"
  }, questions.map(function (question, index) {
    return React__default.createElement(BreakdownRow, {
      key: question.title,
      rowNum: index + 1,
      title: question.title,
      percentage: question.answers[0]
    });
  })));
};

var mapState$2 = function mapState(state, props) {
  var section = props.section;
  return {
    questions: getQuestions(state, section)
  };
};

var Breakdown$1 = reactRedux.connect(mapState$2)(Breakdown);

var appRoot = function appRoot() {
  return typeof document !== "undefined" && document.getElementById("root");
};

var convertNumToString = {
  2: "two",
  3: "three",
  4: "four",
  5: "five",
  6: "six",
  7: "seven",
  8: "eight",
  9: "nine",
  10: "ten"
};

var Explanation = function Explanation(_ref) {
  var setVisibility = _ref.setVisibility,
      heading = _ref.heading,
      score = _ref.score,
      section = _ref.section,
      numQuestions = _ref.numQuestions;
  return reactDom.createPortal(React__default.createElement(components.Modal, {
    bg: "light.0",
    onToggle: function onToggle() {
      return setVisibility(false);
    },
    width: 1 / 6,
    my: [5]
  }, React__default.createElement(components.Utils.DisableScroll, null), React__default.createElement(components.Flex, {
    flexDirection: "column",
    width: 1 / 1,
    alignItems: "center"
  }, React__default.createElement(ExplanationTopBar, {
    setVisibility: setVisibility,
    heading: heading
  }), React__default.createElement(components.Card, {
    width: 1 / 1,
    alignItems: "center",
    px: [3, 4]
  }, React__default.createElement(PercentageGraphic, {
    score: score * 100
  }), numQuestions > 1 ? React__default.createElement(components.Text, {
    width: 3 / 4,
    textAlign: "center",
    fontWeight: 500,
    fontSize: 3
  }, "These ", convertNumToString[numQuestions], " questions combine to make up your overall score for ", heading, ":") : React__default.createElement(components.Text, {
    width: 3 / 4,
    textAlign: "center",
    fontWeight: 500,
    fontSize: 3
  }, "This question makes up your overall score for ", heading, ":"), React__default.createElement(Breakdown$1, {
    heading: heading,
    section: section
  }), React__default.createElement(components.Text, {
    textAlign: "center",
    fontSize: 3,
    fontWeight: 500,
    color: "dark.2",
    mb: 3
  }, "If your score for ", heading, " indicates scope for improvement then you should look at the scores for each questions to pinpoint where any issues lie.")))), appRoot());
};

var _StyledH = styled__default(components.H4).withConfig({
  displayName: "StepResult___StyledH",
  componentId: "m2oh6u-0"
})(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);

var StepResult = function StepResult(_ref) {
  var heading = _ref.heading,
      scoreResult = _ref.scoreResult,
      section = _ref.section,
      numQuestions = _ref.numQuestions;

  var _useState = React.useState(false),
      showExplanation = _useState[0],
      setShowExplantation = _useState[1];

  return React__default.createElement(components.Flex, {
    flexDirection: "column",
    alignItems: "center",
    width: [40 / 100, 5 / 16],
    my: 2,
    mx: [2, 0]
  }, React__default.createElement(_StyledH, {
    fontSize: 4,
    fontWeight: 500,
    textAlign: "center",
    color: "dark.2",
    width: 1 / 1
  }, heading), React__default.createElement(PercentageGraphic, {
    score: scoreResult && scoreResult.score * 100
  }), React__default.createElement(components.Button, {
    variant: "secondary.0",
    disabled: scoreResult && !scoreResult.score,
    onClick: function onClick() {
      return setShowExplantation(true);
    }
  }, "Explanation"), showExplanation ? React__default.createElement(Explanation, {
    score: scoreResult && scoreResult.score,
    setVisibility: setShowExplantation,
    heading: heading,
    section: section,
    numQuestions: numQuestions
  }) : null);
};

var mapState$3 = function mapState(state, props) {
  var section = props.section;
  return {
    scoreResult: getScoreResult(state, section),
    numQuestions: getQuestions(state, section).length
  };
};

var StepResult$1 = reactRedux.connect(mapState$3)(StepResult);

var stepResults = [{
  heading: "Rewards and Recognition",
  section: "sixSteps_reward"
}, {
  heading: "Information Sharing",
  section: "sixSteps_information"
}, {
  heading: "Empowerment",
  section: "sixSteps_empowerment"
}, {
  heading: "Well-Being",
  section: "sixSteps_wellBeing"
}, {
  heading: "Instilling Pride",
  section: "sixSteps_pride"
}, {
  heading: "Job Satisfaction",
  section: "sixSteps_jobSatisfaction"
}];

var SixSteps = function SixSteps(_ref) {
  var heading = _ref.heading,
      subHeading = _ref.subHeading,
      Label = _ref.label;
  return React__default.createElement(ResultCard, null, React__default.createElement(ReportItem, {
    heading: heading,
    subHeading: subHeading
  }, Label && React__default.createElement(Label, null), React__default.createElement(components.Flex, {
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    py: 5
  }, stepResults.map(function (result) {
    return React__default.createElement(StepResult$1, {
      key: result.section,
      heading: result.heading,
      section: result.section
    });
  })), React__default.createElement(components.Box, {
    bg: "primary.5",
    p: 4
  }, React__default.createElement(components.Text, {
    fontSize: 3,
    display: "block",
    mb: 1,
    fontWeight: 400,
    color: "dark.2"
  }, "If your score is below 60% in any area, we suggest that you get some guidance on how to improve your score."), React__default.createElement(components.Text, {
    fontSize: 3,
    display: "block",
    mb: 0,
    fontWeight: 400,
    color: "dark.2"
  }, "Click the buttons below each section to view the questions that make up your score in each area."))));
};

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  & > :last-child {\n    margin-bottom: ", "px;\n  }\n\n  & > div {\n    @media (min-width: ", "px) {\n      width: ", ";\n      margin-left: ", ";\n      margin-right: ", ";\n    }\n\n    @media (min-width: ", "px) {\n      width: ", ";\n    }\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper = styled__default(components.Flex)(_templateObject$5(), function (_ref) {
  var theme = _ref.theme;
  return theme.space[3];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints[0];
}, function (_ref3) {
  var theme = _ref3.theme;
  return "calc(50% - " + theme.space[2] + "px - " + theme.space[2] + "px)";
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.space[2] + "px";
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space[2] + "px";
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints[1];
}, function (_ref7) {
  var theme = _ref7.theme;
  return "calc(33% - " + theme.space[2] + "px - " + theme.space[2] + "px)";
});

var trophy = function trophy(props) {
  return React__default.createElement("svg", props, React__default.createElement("defs", null, React__default.createElement("style", null, ".a", "{", "fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;fill-rule:evenodd", "}")), React__default.createElement("path", {
    className: "a",
    d: "M5.365 3.076H.504v2.392a5.747 5.747 0 0 0 4.978 5.692M33.601 3.076h4.861v2.392a5.747 5.747 0 0 1-4.978 5.692M14.342 5.274v6.661a5.1 5.1 0 0 0 3.8 4.933 10.215 10.215 0 0 0 1.658.185"
  }), React__default.createElement("path", {
    className: "a",
    d: "M8.889.5h20.666v11.781a9.728 9.728 0 0 1-1.051 4.392 10.355 10.355 0 0 1-17.889.75 10.756 10.756 0 0 1-1.7-5.808C8.891 8.114 8.889.5 8.889.5zM15.792 25.716c-.34 5.06 7.649 5.3 7.145 0M7.822 38.266h22.957M19.301 38.266V29.98"
  }));
};

trophy.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 38.966 38.766"
};

var information = function information(props) {
  return React__default.createElement("svg", props, React__default.createElement("defs", null, React__default.createElement("style", null, ".a,.b,.c", "{", "fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5", "}", ".a", "{", "stroke-width:.995px", "}", ".a,.b", "{", "fill-rule:evenodd", "}", ".c", "{", "stroke-width:.999px", "}")), React__default.createElement("path", {
    className: "a",
    d: "M19.505 3.787a19.2 19.2 0 1 0 6.34-.015 19.2 19.2 0 1 1-6.34.015z"
  }), React__default.createElement("path", {
    className: "b",
    d: "M22.723 20.525v13.3"
  }), React__default.createElement("circle", {
    className: "c",
    cx: "2.5",
    cy: "2.5",
    r: "2.5",
    transform: "translate(20.223 11.879)"
  }));
};

information.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 45.444 45.444"
};

var heart = function heart(props) {
  return React__default.createElement("svg", props, React__default.createElement("defs", null, React__default.createElement("style", null, ".a,.b", "{", "fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;fill-rule:evenodd", "}", ".a", "{", "stroke-width:1.001px", "}", ".b", "{", "stroke-width:1.003px", "}")), React__default.createElement("path", {
    className: "a",
    d: "M26.986 6.284c3.332-.596 6.19 1.44 7.085 4.947"
  }), React__default.createElement("path", {
    className: "b",
    d: "M19.528 6.606C23.534-.735 31.544-.735 35.55 2.935s4.005 11.013 0 18.355c-2.8 5.506-10.014 11.013-16.022 14.683C13.52 32.302 6.31 26.795 3.507 21.29c-4.006-7.342-4.006-14.684 0-18.355s12.015-3.67 16.021 3.671z"
  }));
};

heart.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39.055 36.475"
};

var star = function star(props) {
  return React__default.createElement("svg", props, React__default.createElement("defs", null, React__default.createElement("style", null, ".a", "{", "fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;stroke-width:.992px;fill-rule:evenodd", "}")), React__default.createElement("path", {
    className: "a",
    d: "M19.789 6.769s2.164 7.184 2.677 8.881a.5.5 0 0 0 .477.356h13.462M.496 16.006h12.667a.507.507 0 0 0 .477-.336c.777-2.252 5.2-15.039 5.2-15.039M4.286 20.304s5.486 3.394 6.872 4.256a.49.49 0 0 1 .221.558c-.442 1.584-2.2 7.953-2.977 10.765a.5.5 0 0 0 .769.543 5293.13 5293.13 0 0 0 9.373-6.6.506.506 0 0 1 .592.009c1.343 1.006 6.97 5.234 9.434 7.085a.5.5 0 0 0 .786-.531c-.813-2.97-2.659-9.744-3.109-11.4a.5.5 0 0 1 .23-.564l7.093-4.145"
  }));
};

star.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36.9 37.545"
};

var thumbsUp = function thumbsUp(props) {
  return React__default.createElement("svg", props, React__default.createElement("defs", null, React__default.createElement("style", null, ".a,.b", "{", "fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;stroke-width:1.001px", "}", ".b", "{", "fill-rule:evenodd", "}")), React__default.createElement("path", {
    className: "a",
    d: "M.5 14.75h4.813v19.067H.5z"
  }), React__default.createElement("path", {
    className: "b",
    d: "M8.464 14.75h2.555a.5.5 0 0 0 .407-.209l3.765-5.269a.505.505 0 0 0 .093-.291v-5.3A3.1 3.1 0 0 1 17.169.827c.121-.037.24-.081.36-.119a4.095 4.095 0 0 1 5.306 3.91v9.733a.5.5 0 0 0 .39.488l9.163 2.067a3.36 3.36 0 0 1 2.537 4.028c-.817 3.57-2.1 9.2-2.855 12.484a3.36 3.36 0 0 1-3.277 2.612H17.975a.5.5 0 0 1-.148-.022l-9.3-2.858"
  }));
};

thumbsUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 35.523 36.529"
};

var person = function person(props) {
  return React__default.createElement("svg", props, React__default.createElement("defs", null, React__default.createElement("style", null, ".a,.b", "{", "fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5", "}", ".a", "{", "stroke-width:1.003px", "}", ".b", "{", "fill-rule:evenodd", "}")), React__default.createElement("circle", {
    className: "a",
    cx: "9.994",
    cy: "9.994",
    r: "9.994",
    transform: "translate(5.657 .501)"
  }), React__default.createElement("path", {
    className: "b",
    d: "M8.029 24.552l-5.928 2.607a1 1 0 0 0-.592.81c-.188 1.762-.755 7.1-1 9.428a1 1 0 0 0 .994 1.106H29.83a1 1 0 0 0 .995-1.1l-.935-9.342a1 1 0 0 0-.586-.814l-6.1-2.724"
  }));
};

person.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.329 39.003"
};
var Icons = {
  trophy: trophy,
  information: information,
  heart: heart,
  star: star,
  thumbsUp: thumbsUp,
  person: person
};

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  flex-shrink: 0;\n\n  svg {\n    max-width: 38px;\n    max-height: 38px;\n  }\n\n  path {\n    stroke: ", ";\n  }\n\n  circle {\n    stroke: ", ";\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}
var IconWrapper = styled__default(components.Flex)(_templateObject$6(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondary[0];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondary[0];
});

var PlanIcon = function PlanIcon(_ref3) {
  var name = _ref3.name,
      props = _objectWithoutPropertiesLoose(_ref3, ["name"]);

  var SelectedIcon = Icons[name];
  return React__default.createElement(IconWrapper, _extends({
    alignItems: "center",
    justifyContent: "center",
    bg: "secondary.4",
    borderRadius: 99,
    width: 64,
    height: 64
  }, props), React__default.createElement(SelectedIcon, {
    width: "38px"
  }));
};

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-weight: 500;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}
var External = styled__default.a(_templateObject$7(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary[0];
});

var ExternalLink = function ExternalLink(_ref2) {
  var _ref2$to = _ref2.to,
      to = _ref2$to === void 0 ? "/" : _ref2$to,
      children = _ref2.children;
  return React__default.createElement(External, {
    href: to,
    target: "_blank"
  }, children);
};

var ActionPlansPoint = function ActionPlansPoint(_ref) {
  var actionPoint = _ref.actionPoint;
  return React__default.createElement(components.Paragraph, {
    color: "dark.2",
    fontSize: 3,
    fontWeight: 500,
    textAlign: "left",
    bg: "dark.7",
    borderRadius: 4,
    my: 3,
    p: 3
  }, actionPoint.heading, React__default.createElement(components.List.Wrapper, null, actionPoint.actions.map(function (action) {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(components.List.Item, null, React__default.createElement(components.Box, {
      color: "dark.2",
      fontSize: 3,
      fontWeight: 400
    }, action.placeholder && action.text.includes(action.placeholder.key) ? action.text.split(action.placeholder.key).map(function (textFragment, index) {
      return index === 1 ? React__default.createElement(ExternalLink, {
        to: action.placeholder.url
      }, textFragment) : textFragment;
    }) : action.text)), React__default.createElement(components.List.Wrapper, {
      px: 3
    }, action.children.map(function (child) {
      return React__default.createElement(components.List.Item, {
        fontSize: 3,
        color: "dark.2",
        fontWeight: 400
      }, child);
    })));
  })));
};

var ActionPlansPoint$1 = function ActionPlansPoint$1(_ref) {
  var question = _ref.question,
      pointInfo = _ref.pointInfo;
  var score = question.answers[0] * 10;
  var newlinePointInfo = pointInfo.explanation.replace(/\?/g, "??").split(/\? | : /g);
  return React__default.createElement(components.Box, {
    width: 1 / 1,
    pb: 5
  }, React__default.createElement(components.H2, {
    fontSize: 5,
    fontWeight: 500,
    color: "dark.1",
    pt: 3,
    textAlign: "left"
  }, pointInfo.question), React__default.createElement(components.Paragraph, {
    color: "dark.2",
    fontSize: 3,
    fontWeight: 500,
    textAlign: "left"
  }, "Your score:", React__default.createElement(components.Text, {
    fontSize: 3,
    fontWeight: 500,
    color: getLabelData(score).color,
    pl: 1,
    width: "auto"
  }, " " + score + "%")), React__default.createElement(components.Paragraph, {
    textAlign: "left"
  }, newlinePointInfo.map(function (point) {
    return React__default.createElement(components.Box, {
      flexDirection: "row"
    }, React__default.createElement(components.Text, {
      fontSize: 3,
      py: 3,
      fontWeight: 500,
      color: "dark.2",
      lineHeight: "1.4"
    }, point));
  })), pointInfo.suggestedActions.map(function (actionPoint) {
    return React__default.createElement(ActionPlansPoint, {
      actionPoint: actionPoint
    });
  }));
};

var SupportiveMaterials = function SupportiveMaterials(_ref) {
  var supportiveMaterials = _ref.supportiveMaterials;
  return React__default.createElement(components.Box, {
    bg: "primary.5",
    width: "100%",
    px: 3,
    pt: 3,
    pb: 0
  }, React__default.createElement(components.Paragraph, {
    color: "dark.2",
    fontSize: 3,
    fontWeight: 500,
    textAlign: "left"
  }, "Supportive Materials:"), React__default.createElement(components.Paragraph, {
    fontSize: 3,
    color: "dark.2",
    my: 3,
    py: 1,
    textAlign: "left"
  }, "Use the list below to discover materials that could be helpful on this topic.", React__default.createElement(components.List.Wrapper, {
    pt: 2,
    width: "auto"
  }, supportiveMaterials.map(function (material) {
    return React__default.createElement(components.List.Item, {
      fontSize: 3
    }, React__default.createElement(components.Text, {
      fontSize: 3,
      fontWeight: 500
    }, material.type, " -", " ", React__default.createElement(ExternalLink, {
      to: material.url
    }, React__default.createElement(components.Text, {
      fontSize: 3,
      color: "primary.0",
      fontWeight: "500"
    }, material.title))));
  }))));
};

var FurtherReadingCard = function FurtherReadingCard(_ref) {
  var cardInfo = _ref.cardInfo;
  return React__default.createElement(components.Card, {
    width: 1 / 1,
    alignItems: "center",
    py: 5,
    px: 5,
    marginTop: 4
  }, React__default.createElement(components.Text, {
    textAlign: "center",
    fontSize: 3,
    width: 1 / 1,
    fontWeight: 500,
    color: "dark.2",
    lineHeight: "1.4"
  }, cardInfo.text), React__default.createElement(ExternalLink, {
    to: cardInfo.url
  }, React__default.createElement(components.Button, {
    variant: "secondary.0",
    borderRadius: 20,
    marginTop: 4,
    px: 4
  }, cardInfo.title)));
};

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  -webkit-overflow-scrolling: touch;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  & > div {\n    border-bottom: 1px solid ", ";\n\n    &:last-child {\n      border-bottom: none;\n      padding-bottom: 0;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  text-transform: none;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var appRoot$1 = function appRoot() {
  return typeof document !== "undefined" && document.getElementById("root");
};

var BackButton = styled__default(components.Button)(_templateObject$8());
var SeparatorBox = styled__default(components.Flex)(_templateObject2(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[4];
});
var StyledModal = styled__default(components.Modal)(_templateObject3());

var ActionPlansModal = function ActionPlansModal(_ref2) {
  var questions = _ref2.questions,
      scoreResult = _ref2.scoreResult,
      plan = _ref2.plan,
      setVisibility = _ref2.setVisibility;
  if (!scoreResult) return null;
  return reactDom.createPortal(React__default.createElement(StyledModal, {
    onToggle: function onToggle() {
      return setVisibility(false);
    },
    plan: plan,
    bg: "light.0",
    minWidth: "80%",
    p: [2, 6],
    py: [3, 6],
    my: [0, 5]
  }, React__default.createElement(components.Utils.DisableScroll, null), React__default.createElement(components.Flex, {
    flexDirection: "column",
    width: 1 / 1
  }, React__default.createElement(BackButton, {
    onClick: function onClick() {
      return setVisibility(false);
    },
    leadingIcon: "arrow_back",
    variant: "light.0",
    borderRadius: 24,
    elevation: 1
  }, React__default.createElement(components.Text, {
    marginRight: 4,
    fontWeight: 400,
    color: "dark.2",
    fontSize: 3
  }, "Back to results")), React__default.createElement(components.H2, {
    fontSize: [6, 7],
    fontWeight: 500,
    fontFamily: "serif",
    p: [2, 3],
    textAlign: ["center", "justify"]
  }, "Action Plan - ", plan.heading), React__default.createElement(components.Flex, {
    flexDirection: ["column", "row-reverse"],
    flexWrap: ["nowrap", "wrap"],
    width: 1 / 1
  }, React__default.createElement(components.Flex, {
    flexDirection: "column",
    p: [2, 3],
    width: [1 / 1, 2 / 5]
  }, React__default.createElement(components.Text, {
    textAlign: "center",
    fontSize: 3,
    width: 1 / 1,
    fontWeight: 500,
    color: "dark.2"
  }, "Your overall score for this area:"), React__default.createElement(PercentageGraphic, {
    score: scoreResult.score * 100
  }), React__default.createElement(SupportiveMaterials, {
    supportiveMaterials: plan.supportiveMaterials
  }), plan.furtherReading.map(function (cardInfo) {
    return React__default.createElement(FurtherReadingCard, {
      cardInfo: cardInfo
    });
  })), React__default.createElement(SeparatorBox, {
    flexDirection: "column",
    p: [2, 3],
    textAlign: "justify",
    width: [1 / 1, 3 / 5]
  }, plan.modalInfo.map(function (pointInfo, pointIndex) {
    return React__default.createElement(ActionPlansPoint$1, {
      question: questions[pointIndex],
      pointInfo: pointInfo
    });
  }))))), appRoot$1());
};

var mapState$4 = function mapState(state, props) {
  var section = props.section;
  return {
    questions: getQuestions(state, section),
    scoreResult: getScoreResult(state, section)
  };
};

var ActionPlanModal = reactRedux.connect(mapState$4)(ActionPlansModal);

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  border: 1px solid ", ";\n  text-align: center;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var Wrapper$1 = styled__default(components.Card)(_templateObject$9(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.dark[4];
});

var PlanBox = function PlanBox(_ref2) {
  var plan = _ref2.plan;

  var _useState = React.useState(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  return React__default.createElement(Wrapper$1, {
    p: 3,
    mb: 5,
    elevation: 0,
    alignItems: "center",
    justifyContent: "space-between",
    height: ["auto", "320px"]
  }, React__default.createElement(components.Flex, {
    width: "auto",
    flexDirection: "column",
    alignItems: "center"
  }, React__default.createElement(components.H4, {
    fontSize: 4,
    color: "dark.1",
    mb: 3,
    width: 1 / 1
  }, plan.heading), React__default.createElement(PlanIcon, {
    name: plan.icon || "podium",
    bg: "dark.7"
  })), React__default.createElement(components.Text, {
    fontSize: 3,
    color: "dark.2",
    my: 3,
    width: 1 / 1
  }, plan.paragraph), React__default.createElement(components.Button, {
    variant: "secondary.0",
    onClick: function onClick() {
      return setShowModal(true);
    }
  }, "Action plan"), showModal ? React__default.createElement(ActionPlanModal, {
    section: plan.section,
    setVisibility: setShowModal,
    plan: plan
  }) : null);
};

var ActionPlanItems = [{
  section: "sixSteps_reward",
  heading: "Reward and Recognition",
  icon: "trophy",
  paragraph: "Recognition can be a more powerful ongoing motivator than pay. If you have a low score in this area, find out how to improve it by clicking the button below.",
  modalInfo: [{
    question: "Do you feel appropriately rewarded for your work?",
    explanation: "It is not unusual to find people who say they are not paid enough. Why wouldn’t they! Pay, however, can only minimise discontent rather than motivating. Let me explain. If somebody feels they are 5% underpaid it niggles away at them, but if they feel they are paid 5% more than they are worth, they don’t work any harder. The first step is to reassure yourself that you are being paid fairly and then see what you can do to improve your pay. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Understand the pay range for the job/jobs in question by asking your manager. (Alternatively you can look at external @LINK@pay benchmarking information@LINK@.)",
        children: [],
        placeholder: {
          key: "@LINK@",
          url: "https://www.payscale.com/index/UK"
        }
      }, {
        text: "Discuss with your manager where you sit in the range and why. Don’t be angry or disagree, just ask questions in order to gain a better understanding.",
        children: []
      }, {
        text: "Set out a plan, with your manager’s support, to improve your contribution and as a result your pay.",
        children: []
      }, {
        text: "Consider what opportunities exist for you to be paid an additional bonus for work and projects completed to a high standard.",
        children: []
      }, {
        text: "Are there more responsibilities you can take on in order to increase your earning power?",
        children: []
      }, {
        text: "Can you learn new skills or build your knowledge to earn more?",
        children: []
      }, {
        text: "If your current job does not bring you the pay levels you want, what added skills and abilities are required for a promotion?",
        children: []
      }]
    }]
  }, {
    question: "Are you happy with your working hours?",
    explanation: "If you score poorly on this question there could be a number of reasons. You should therefore ask yourself the following:: 1. Am I unhappy because I am working too many hours? 2. Am I unhappy because I am working too few hours? 3. Am I unhappy because I would like more flexibility in my working hours? 4. Am I unhappy because I don’t know what my working hours are/will be? 5. Am I unhappy about my working hours because of my pay? (For instance too many hours for the pay you receive or not enough hours for the pay desired.)",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Which of the reasons above is making feel unhappy about your working hours?",
        children: []
      }, {
        text: "If number 1 and 5 - consider how you might contain your workload within the working week. Agree with your manager and colleagues that you will answer emails between 8am to 6pm on working days but not outside of those hours or at the weekend.",
        children: []
      }, {
        text: "If number 2 and 5 - discuss with your manager what scope exists to do more hours. Can you work in another department too? Is there more training you could have to take on more tasks?",
        children: []
      }, {
        text: "If number 3 - discuss with your manager how you might you might work more flexibly. How might that help them and the organisation as well as you?",
        children: []
      }, {
        text: "If number 4 - try to understand from your manager the challenges they have with scheduling. Explain to your manager the challenges you have from not knowing your working hours. Try to find a mutually helpful plan.",
        children: []
      }]
    }]
  }, {
    question: "Do you feel recognised when you do something well?",
    explanation: "Recognition is one of the most powerful motivators and causes of high levels of workplace engagement. Yet on average people are only thanked for what they do once every four and a half months, whereas they are criticised twice a week. Praise creates a positive working environment. If you score poorly on this question you can do the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Praise your manager and colleagues when they do something well. Hopefully your lead might catch on!",
        children: []
      }, {
        text: "If you manage people you might consider the points below or even suggest them to your manager.",
        children: []
      }, {
        text: "Recognise and praise somebody when they do something well.",
        children: []
      }, {
        text: "If somebody completes work you think they can improve upon use it as an opportunity to coach (i.e ask: ‘how well did you feel that went’, ‘could you have done that differently’, or ‘what more support might you need if you were to do that task again’ etc) so that the individual feels that they are learning rather than being criticised.",
        children: []
      }, {
        text: "Send somebody a note/email/card when they do something well.",
        children: []
      }, {
        text: "Give somebody a small gift (chocolate/flowers/wine) when they do something that has impressed you.",
        children: []
      }, {
        text: "Recognise individual successes publicly and discuss failures privately.",
        children: []
      }, {
        text: "For outstanding work, recognise an individual with a bonus - either cash or tickets to go and see a show, football match, or to go out for dinner with their partner.",
        children: []
      }, {
        text: "Take every opportunity to recognise and celebrate your team or a member of your team’s success.",
        children: []
      }, {
        text: "Ask your boss to recognise individuals in your team who have done well.",
        children: []
      }]
    }]
  }],
  supportiveMaterials: [{
    type: "Article",
    title: "10 Powerful Ways to Improve Your Employee Recognition",
    url: "https://engaging.works/business-library/browse/articles/5d76a722c289ff00166b4145"
  }, {
    type: "Article",
    title: "How to Get the Recognition at Work You Deserve",
    url: "https://engaging.works/business-library/browse/articles/5d750d53c289ff00166b408c"
  }, {
    type: "Lecture",
    title: "The Happy Secret to Better Work",
    url: "https://engaging.works/business-library/browse/lectures/5d890db1c289ff00166b4471"
  }],
  furtherReading: [{
    text: "Find many more relevant materials in our Business Library.",
    title: "BUSINESS LIBRARY",
    url: "https://engaging.works/business-library/discover"
  }, {
    text: "Match with a Mentor using our unique Mentor Matching service.",
    title: "MENTOR MATCHER",
    url: "https://v1.engaging.works/ew/mentors/matcher"
  }]
}, {
  section: "sixSteps_information",
  heading: "Information Sharing",
  icon: "information",
  paragraph: "There is often a disconnect (real or perceived) between the information your managers are providing and what you are receiving. Read the action plan to help you to identify opportunities to improve.",
  modalInfo: [{
    question: "Do you have enough information to do your job well?",
    explanation: "This question goes to the heart of whether you feel you have been properly trained to do your job well or have enough information on an ongoing basis to do what is required. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Review whether you have been trained effectively to complete your tasks. If not, you should consider speaking to your manager.",
        children: []
      }, {
        text: "Is information readily at hand for you to complete your job efficiently? If not, you should consider speaking to your manager.",
        children: []
      }, {
        text: "Is new information relevant to your job effectively communicated. If not consider how it might be and discuss with your manager.",
        children: []
      }, {
        text: "Do you have regular team meetings to share updates affecting their jobs? If not suggest that you do.",
        children: []
      }]
    }]
  }, {
    question: "Do you feel information is openly shared with you at work?",
    explanation: "This question is about whether you understand how the organisation is performing and your role in whether your manager is being transparent with information. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Are there routine meetings to share how the organisation is performing and it’s plans? If so, do you attend? If not, how might you ask for this information?",
        children: []
      }, {
        text: "Does the organisation give routine updates online or through reports? Can you see these?",
        children: []
      }, {
        text: "Are you taking every opportunity to ask questions and feedback about the organisation’s and your department’s performance",
        children: []
      }, {
        text: "Does the organisation have a newsletter or communication portal to keep employees up to date? Do you keep up to date with this?",
        children: []
      }]
    }]
  }, {
    question: "Do you feel your views are heard at work?",
    explanation: "If you do not feel your views are listened to then it is unlikely you will feel empowered or engaged to make a full contribution to the organisation. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Ask yourself what you are doing to give feedback to your manager and colleagues. Is it constructive? Positivity intended?",
        children: []
      }, {
        text: "Are you listening as much as giving your views?",
        children: []
      }, {
        text: "You should try and ask for five bits of information before you give one piece of advice or direction.",
        children: []
      }, {
        text: "Are there good suggestions/ideas schemes or formal feedback sessions you can contribute to?",
        children: []
      }, {
        text: "Remember everyone has a different viewpoint because everyone has different experiences, education and upbringing. None are right or wrong they are just what people think based on those factors. All contributions should be welcomed to bring diversity of view, collective agreement and understanding. Try to understand why others have the views they have before you jump in to change them!",
        children: []
      }]
    }]
  }],
  supportiveMaterials: [{
    type: "Article",
    title: "To Be Transparent or Not to Be Transparent at Work",
    url: "https://engaging.works/business-library/browse/articles/5d76a92ec289ff00166b4168"
  }, {
    type: "Article",
    title: "8 Questions You Should be Asking Your Boss",
    url: "https://engaging.works/business-library/browse/articles/5d76aa36c289ff00166b4179"
  }, {
    type: "Article",
    title: "Active listening - Hear What People Are Really Saying",
    url: "https://engaging.works/business-library/browse/articles/5d7a5b22c289ff00166b41f2"
  }, {
    type: "Book",
    title: "Difficult Conversations",
    url: "https://engaging.works/business-library/browse/books/11785"
  }],
  furtherReading: [{
    text: "Find many more relevant materials in our Business Library.",
    title: "BUSINESS LIBRARY",
    url: "https://engaging.works/business-library/discover"
  }, {
    text: "Start sharing ideas and asking questions via our worldwide platform, the Global Hub",
    title: "GLOBAL HUB",
    url: "https://engaging.works/global-hub"
  }]
}, {
  section: "sixSteps_empowerment",
  heading: "Empowerment",
  icon: "person",
  paragraph: "Your empowerment is influenced by both you and those around you. Answering the questions in the Action Plan will help you understand your potential areas to focus on.",
  modalInfo: [{
    question: "Are you empowered to make decisions?",
    explanation: "When you own something you care more. The secret of empowerment is that you feel you own things, like decisions, projects, action plans. As a result of ownership you feel more accountable and care more about the outcomes. It is also about whether you have the freedom to do what you need to do, to be effective in your job, making the organisation more effective and increasing your earning potential. Empowerment requires your manager to delegate and delegation requires training and coaching. But when done effectively the whole organisation moves more quickly. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Are you clear on the freedoms you have and the flexibility you can exercise in your job? If you’re not, ask your manager to be clearer.",
        children: []
      }, {
        text: "Do you feel your manager and the organisation set the right parameters for you to make decisions? If not, discuss with your manager what more you’d like and why this will benefit everyone.",
        children: []
      }, {
        text: "Do you have the right level of training and experience for the delegations you have? If not discuss with you manager what more you need.",
        children: []
      }, {
        text: "When things go wrong, and they will, admit it and discuss with your manager what you have learned and, if anything, what more training or coaching is required.",
        children: []
      }]
    }]
  }, {
    question: "Do you have the resources you need to do your job well?",
    explanation: "In any business resources are tightly managed. Too much resource means that the business will not make as much profit or be as efficient as it might be. Too little resource places considerable strain on you and the team. It’s a fine balance. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Consider what more you need to do your job well. Some of these you will be able to control, others not. This is likely to breakdown into a few key areas:",
        children: ["More people", "More hours", "Less work/more realistic timeframes", "Better equipment", "Better IT"]
      }, {
        text: "Talk to your manager about how improving any of the above can improve performance.",
        children: []
      }, {
        text: "Consider how you might work more efficiently to relieve the pressure on hours and people.",
        children: []
      }, {
        text: "Consider with your team how you might be able to invest more in resources through generating more sales and/or efficiency.",
        children: []
      }, {
        text: "Do you understand the economics of the business and the constraints there may be at this time on additional resources?",
        children: []
      }]
    }]
  }, {
    question: "Do you feel trusted to make decisions?",
    explanation: "This question is about whether you feel trusted to operate within parameters set by the organisation and your manager. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Do you clearly understand what you can make decisions about? If not, you should ask your manager to clarify.",
        children: []
      }, {
        text: "Is your manager over-controlling and asking to be consulted about decisions which they have said are delegate? If so, reconfirm with you manager what the boundaries are.",
        children: []
      }, {
        text: "Do you feel confident that they can make the right decision within the parameters set? If not, ask your manager for more training and coaching.",
        children: []
      }]
    }]
  }],
  supportiveMaterials: [{
    type: "Article",
    title: "8 Ways to Become More Empowered at Work",
    url: "https://engaging.works/business-library/browse/articles/5d7a62dac289ff00166b4246"
  }, {
    type: "Article",
    title: "3 Simple Strategies to Empowering Yourself at Work",
    url: "https://engaging.works/business-library/browse/articles/5d7a67f8c289ff00166b425c"
  }, {
    type: "Article",
    title: "Managers Must Delegate Effectively to Develop Employees",
    url: "https://engaging.works/business-library/browse/articles/5d890bfcc289ff00166b444d"
  }, {
    type: "Podcast",
    title: "Successful Mentoring",
    url: "https://engaging.works/business-library/browse/podcasts/5d1341f9dcb3ad8a5440ecbb"
  }],
  furtherReading: [{
    text: "Find more relevant reading materials in our Business Library.",
    title: "BUSINESS LIBRARY",
    url: "https://engaging.works/business-library/discover"
  }, {
    text: "Need help developing your career? Take our purposefully designed tests to help your Career Development.",
    title: "DEVELOP YOUR CAREER",
    url: "https://v1.engaging.works/ew/profile"
  }]
}, {
  section: "sixSteps_wellBeing",
  heading: "Well-being",
  icon: "heart",
  paragraph: "Healthy employees are more committed, and committed employees are healthier. Find out how to improve your score with our well-being action plan.",
  modalInfo: [{
    question: "Do you feel the organisation cares for your well-being?",
    explanation: "If you score poorly on this question, you’ll need to consider whether your concerns are about the organisation in general or the way you are being managed. You can look at scores about management relationships in the Job Satisfaction Action Plan.",
    suggestedActions: [{
      heading: "If you have a poor score as a result of the organisation not caring, consider the following steps to improve your well-being:",
      actions: [{
        text: "Are your working hours clearly defined with an understand of the split between work time and home time?",
        children: []
      }, {
        text: "Are your working hours too great and creating extra pressure and stress?",
        children: []
      }, {
        text: "Do you feel equipped for your job - sufficient training, resources, support, ability?",
        children: []
      }, {
        text: "Can you suggest ideas to your manager to help you and your colleagues be healthier (e.g. gym memberships classes etc)?",
        children: []
      }, {
        text: "Can you suggest things to help the organisation promote a healthy lifestyle (e.g. free fruit, encouraging lunchtime walking etc)?",
        children: []
      }]
    }, {
      heading: "If you have a poor score as a result of feeling that your manager doesn’t care, you might consider the following steps:",
      actions: [{
        text: "Try to speak to your manager each day. Ask how they are to each day - you’ll be surprised how well this works!",
        children: []
      }, {
        text: "Show concern when they are unwell.",
        children: []
      }, {
        text: "Wish them a happy break/holiday.",
        children: []
      }, {
        text: "Take a genuine interest in them and their personal lives.",
        children: []
      }, {
        text: "If taking the lead on these things doesn’t improve your relationship with your manager consider another role within the organisation or look to move. You can use the Engaging Works Jobs Board - it even shows the happier industries to work in and companies to work for.",
        children: []
      }]
    }]
  }, {
    question: "Are you happy with your working environment?",
    explanation: "There are a number of things that may lead people to express unhappiness over their working environment. It could be their journey to work, parking availability, that the office is overcrowded or dark. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Consider which elements of your working environment are causing you to be unhappy and how you might help your manager find a solution to make things better for you. For instance they might not be able to improve your journey to work, but perhaps you could have more flexible working hours. ",
        children: []
      }, {
        text: "Check if your colleagues feel similarly and work together on a plan to improve things.",
        children: []
      }, {
        text: "If your concern is related to a health and safety issue take immediate action. Notify your manager and all relevant office holders in your organisation. Stop work if there is an imminent danger.",
        children: []
      }]
    }]
  }, {
    question: "Do you feel relaxed and calm at work?",
    explanation: "There are many reasons why people may feel anxious/depressed coming into work. It may be something to do with their home life and/or their time at work. If you have taken the individual Engaging Works Workplace Happiness Survey and scored poorly for Well-being you will be directed to take the National Health Service anxiety depression test and given clinical advice.",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "If you are concerned at any time about your mental well-being, take the Workplace Happiness Survey and if suggested, an additional NHS test.",
        children: []
      }, {
        text: "Try to share your concerns with your manager.",
        children: []
      }, {
        text: "If it’s your job which is causing concern discuss what support, training, resources, time etc you may need to feel better about what you are doing. The Workplace Happiness Survey will help you identify where your concerns lie. ",
        children: []
      }, {
        text: "If you conclude you are in the wrong job or role use the free Engaging Works Career Developer to find which career and role might suit you best. There a career path test and a personality test.",
        children: []
      }, {
        text: "If it is your relationship with your line manager that is the concern but you like your job and the organisation, speak to a member of the HR team or perhaps get a mentor. You can connect with one free of charge by using the Engaging Works Mentor Matcher.",
        children: []
      }]
    }]
  }],
  supportiveMaterials: [{
    type: "Article",
    title: "10 Ways to Improve Wellbeing in the Workplace",
    url: "https://engaging.works/business-library/browse/articles/5d890f7bc289ff00166b4475"
  }, {
    type: "Article",
    title: "22 Well-being in the Workplace Initiatives That You Can Start Today",
    url: "https://engaging.works/business-library/browse/articles/5d8a3082c289ff00166b4524"
  }, {
    type: "Article",
    title: "Improving Physical Health and Well-being at Work",
    url: "https://engaging.works/business-library/browse/articles/5d8c4f4ac289ff00166b4584"
  }, {
    type: "Book",
    title: "Quantum Wellness",
    url: "https://engaging.works/business-library/browse/books/122922"
  }, {
    type: "Article",
    title: "Managing Workplace Issues",
    url: "https://engaging.works/business-library/browse/articles/5d891b9ac289ff00166b449e"
  }, {
    type: "Article",
    title: "Top Tips for Staying Well at Work",
    url: "https://engaging.works/business-library/browse/articles/5d8a2f77c289ff00166b4506"
  }],
  furtherReading: [{
    text: "Find more relevant reading materials in our Business Library.",
    title: "BUSINESS LIBRARY",
    url: "https://engaging.works/business-library/discover"
  }, {
    text: "Match with a Mentor using our unique Mentor Matching service.",
    title: "MENTOR MATCHER",
    url: "https://v1.engaging.works/ew/mentors/matcher"
  }, {
    text: "Take our tests to assess which career and role might suit you best.",
    title: "TAKE TESTS",
    url: "https://v1.engaging.works/ew/profile"
  }]
}, {
  section: "sixSteps_pride",
  heading: "Instilling Pride",
  icon: "star",
  paragraph: "You gain pride from the products and services your organisations provide, the attitudes and behaviour of your colleagues and managers. Find out new ways to think about this using our action plan.",
  modalInfo: [{
    question: "Do you feel proud to work for your organisation?",
    explanation: "It’s great if you feel proud when you tell someone where you work. Academic research suggests that where people feel a sense of purpose, they contribute more to the organisation’s success and are happier. People working for charities usually score highly on this dimension. If you score poorly on this question you should consider doing the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Have you considered how the organisation you work for helps society: employing people, paying taxes, charitable activity, social purpose.",
        children: []
      }, {
        text: "If the organisation does not have a clearly articulated social purpose what might it be? For example if you make mattresses you’re helping people sleep better so that they’re happier. If you grow apples you are preserving and protecting the countryside and helping people eat healthily.",
        children: []
      }, {
        text: "Do you or your colleagues support a local charity by perhaps. You could consider donating time or running sponsored events.",
        children: []
      }]
    }]
  }, {
    question: "How likely are you to recommend friends and family to work at your organisation?",
    explanation: "One of the surest ways to test if people are happy where they work is to ask if they would recommend where they work to their friends and family. If you wouldn’t recommend your workplace you need to think if that can be fixed or if you are in the wrong organisation or job. You should view the Organisation Satisfaction Matrix. You might see that you fall into the Anarchists category and unlikely to talk positively about where you work. This is bad for you and the organisation.",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Consider why you have scored poorly on this point; referring back to your scores on other questions.",
        children: []
      }, {
        text: "Do you feel you can address the points raised?",
        children: []
      }, {
        text: "If you can’t and your score in the area suggest you are unhappy consider how you might move to another roles where you work or another organisations where they will be happier. You can use the Engaging Works Career Developer to test your in the right career and your personality profile matches well what you are doing or if you want to consider other jobs in other companies you can visit the Engaging Works Jobs Board.",
        children: []
      }]
    }]
  }, {
    question: "Do you feel you are doing something worthwhile?",
    explanation: "Everyone wants to feel that they are making a contribution to an organisation’s success and society. There’s a wonderful story about President J F Kennedy visiting NASA to see the space rockets. In the line to meet him was a cleaner. When President Kennedy asked him what his job was, he said “putting a man on the moon!” Teachers and nurses all tend to score highly on this question but so can others if they understand the contribution they are making.",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Do you appreciate the importance of your role to the success of the organisation?",
        children: []
      }, {
        text: "Do you appreciate the contribution your organisation is making to society?",
        children: []
      }]
    }]
  }],
  supportiveMaterials: [{
    type: "Article",
    title: "3 Ways to Be Proud of Your Job",
    url: "https://engaging.works/business-library/browse/articles/5d8c5650c289ff00166b45ee"
  }, {
    type: "Article",
    title: "7 Reasons to Take Pride in Your Work or Go Do Something Else",
    url: "https://engaging.works/business-library/browse/articles/5d8c56eac289ff00166b45ff"
  }, {
    type: "Article",
    title: "Do Your Career and Work Values Align?",
    url: "https://engaging.works/business-library/browse/articles/5d930545c289ff00166b470c"
  }],
  furtherReading: [{
    text: "Find more relevant reading materials in our Business Library.",
    title: "BUSINESS LIBRARY",
    url: "https://engaging.works/business-library/discover"
  }, {
    text: "Need help developing your career? Take our purposefully designed tests to help your Career Development.",
    title: "DEVELOP YOUR CAREER",
    url: "https://v1.engaging.works/ew/profile"
  }, {
    text: "If you are considering looking for a new role, you can browse jobs for free on the Jobs Board.",
    title: "BROWSE JOBS",
    url: "https://engaging.works/find-work/jobs"
  }]
}, {
  section: "sixSteps_jobSatisfaction",
  heading: "Job Satisfaction",
  icon: "thumbsUp",
  paragraph: "Do you go home at the end of the day or the end of the week feeling that you have made a positive contribution to your organisation and its customers? If you are struggling in this area, our action plan may help.",
  modalInfo: [{
    question: "Do you feel you are being developed?",
    explanation: "For many people it is important that they feel they are being developed and as a consequence can increase their earning potential. Even mature employees want to keep learning and it’s vital for new employees if the organisation is to achieve its potential. Employees want to feel that their boss is developing them rather than just helping make their boss look good. If you score poorly on this question you should consider the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Do you spend time considering where you might improve your performance? In the Engaging Works Career Diary (coming soon) you can record each day your areas for development. What went well what went less well and what will you do differently in the future.",
        children: []
      }, {
        text: "Do you ask your manager and colleagues how you might improve your performance and learn more on the job?",
        children: []
      }, {
        text: "Have you used the  Engaging Works Business Library to find more resources and information to help you develop?",
        children: []
      }, {
        text: "Have you used Engaging Works Mentor Matcher service to search for a mentor?",
        children: []
      }, {
        text: "Do you have a regular review of performance with your manager to discuss your training and development?",
        children: []
      }]
    }]
  }, {
    question: "Do you have a good relationship with your line manager?",
    explanation: "The most critical relationship in the workplace is between an individual and their boss. 83% of people leave their jobs because of the poor relationship they have with their line manager, even if they work for a great company. There can be many reasons for this, but if you have a low score in this area you may like to consider the following:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Take an interest in your manager - finding out about their personal life and their hopes and ambitions for work and their wellbeing. If you are interested in them there’s a high chance they’ll be interested in you.",
        children: []
      }, {
        text: "Recognise that we are all different as we have different skills, experiences and backgrounds.",
        children: []
      }, {
        text: "Positively encourage your manager to help you improve your performance. Don’t be defensive.",
        children: []
      }, {
        text: "Be positive. Nobody wants to work with negative colleagues.",
        children: []
      }, {
        text: "Be interested and engaged in your work.",
        children: []
      }, {
        text: "If you do not fit the role or organisation take the positive steps of looking for a new role or organisation.",
        children: []
      }]
    }]
  }, {
    question: "Are you treated with respect?",
    explanation: "It is hard to be satisfied at work if you do not feel respected by your manager and/or colleagues. If you have a low score for this question you can consider:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "Why do you feel you lack respect? Perhaps consider the following and see if you identify with any of these points:",
        children: ["You aren’t paid fairly.", "You’re not recognised when you do something well.", "You don’t feel information is shared with you.", "Your views aren’t heard.", "You don’t feel trusted to make decisions.", "Your well-being is cared for.", "You don’t do a job which is worthwhile.", "You don’t have a good relationship with your manager.", "You are being taken for granted and not developed."]
      }]
    }]
  }, {
    question: "Do you enjoy your job?",
    explanation: "It is possible to work for a great organisation, a great boss, have wonderful colleagues but still feel that you are in the wrong job. It is hard to see, if that is the case, how you can feel happy at work over the long term. If you score poorly on this question you should consider:",
    suggestedActions: [{
      heading: "Suggested Actions:",
      actions: [{
        text: "If you have eliminated the issues listed in the action plan above, and if it is the job itself you don’t enjoy, what would you enjoy doing?",
        children: []
      }, {
        text: "Is that role available in your department or organisation?",
        children: []
      }, {
        text: "What training or support is required to achieve your preferred role?",
        children: []
      }, {
        text: "Take control of your own career. There is a career path and personality profile test on Engaging Works to help you discover where your skills and interests best fit, as well as a Jobs Board to search for new roles and see which are the happiest companies to work for.",
        children: []
      }]
    }]
  }],
  supportiveMaterials: [{
    type: "Article",
    title: "Are You Truly Satisfied With Your Job? How to Find Out",
    url: "https://engaging.works/business-library/browse/articles/5d93061bc289ff00166b4722"
  }, {
    type: "Article",
    title: "How Satisfied Are You With Your Job?",
    url: "https://engaging.works/business-library/browse/articles/5d93088ec289ff00166b4759"
  }, {
    type: "Book",
    title: "Six Steps to Workplace Happiness",
    url: "https://engaging.works/business-library/browse/books/74424"
  }, {
    type: "Article",
    title: "How to Get the Feedback You Need",
    url: "https://engaging.works/business-library/browse/articles/5d9306e8c289ff00166b4734"
  }, {
    type: "Article",
    title: "How to Request Useful Feedback from Managers and Coworkers",
    url: "https://engaging.works/business-library/browse/articles/5dd52714778d280010af1d24"
  }],
  furtherReading: [{
    text: "Find more relevant reading materials in our Business Library.",
    title: "BUSINESS LIBRARY",
    url: "https://engaging.works/business-library/discover"
  }, {
    text: "Match with a Mentor using our unique Mentor Matching service.",
    title: "MENTOR MATCHER",
    url: "https://v1.engaging.works/ew/mentors/matcher"
  }, {
    text: "Need help developing your career? Take our purposefully designed tests to help your Career Development.",
    title: "DEVELOP YOUR CAREER",
    url: "https://v1.engaging.works/ew/profile"
  }]
}];

var ActionPlans = function ActionPlans(_ref) {
  var heading = _ref.heading,
      subHeading = _ref.subHeading;
  return React__default.createElement(ResultCard, null, React__default.createElement(ReportItem, {
    heading: heading,
    subHeading: subHeading
  }, React__default.createElement(Wrapper, {
    flexDirection: ["column", "row"],
    flexWrap: ["nowrap", "wrap"],
    alignItems: "stretch"
  }, ActionPlanItems.map(function (plan) {
    return React__default.createElement(PlanBox, {
      key: plan.section,
      plan: plan
    });
  }))));
};

exports.ActionPlans = ActionPlans;
exports.HoldingPage = HoldingPage;
exports.Loader = Loader;
exports.Matrices = Matrices$1;
exports.OverallScore = OverallScore;
exports.PercentageGraphic = PercentageGraphic;
exports.ReportItem = ReportItem;
exports.ResultCard = ResultCard;
exports.ResultsActions = result_actions;
exports.ResultsMatrix = ResultsMatrix;
exports.ResultsSelectors = result_selectors;
exports.ScoreLabel = ScoreLabel;
exports.SixSteps = SixSteps;
exports.Title = Title;
exports.resultsReducer = reducer;
exports.resultsSaga = saga;
